import { Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';

import { VERTICAL_SPACING } from '../../components/EducationalSlide.components';

export function EstatePlanningGlossary() {
  return (
    <Stack spacing={VERTICAL_SPACING}>
      <EditableRegion regionId="glossary-section" />
    </Stack>
  );
}
